import React from "react";
import "./Techstacks.css";
import { FaReact, FaNodeJs } from "react-icons/fa";
import {
  SiRedux,
  SiHtml5,
  SiMaterialui,
  SiExpress,
  SiRedis
} from "react-icons/si";
import { DiMongodb, DiMysql } from "react-icons/di";
import { SiJavascript } from "react-icons/si";
import { SiNextdotjs, SiChakraui } from "react-icons/si";

export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different">Skills</h2>
        <div className="techsection">
          <div>
            <FaNodeJs />
            <h5>Nodejs</h5>
          </div>

          <div>
          <SiExpress />
          <h5>Express</h5>
          </div>

          <div>
            <DiMysql />
            <h5>MySql</h5>
          </div>

          <div>
            <DiMongodb />
            <h5>MongoDb</h5>
          </div>

          <div>
            <SiRedis />
            <h5>Redis</h5>
          </div>
          

          <div>
            <SiJavascript />
            <h5>Javascript</h5>
          </div>

          <div>
            <SiHtml5 />
            <h5>HTML</h5>
          </div>

          <div>
            <FaReact />
            <h5>React</h5>
          </div>

          <div>
            <SiNextdotjs />
            <h5>Nextjs</h5>
          </div>

          <div>
            <SiRedux />
            <h5>Redux</h5>
          </div>

          <div>
            <SiMaterialui />
            <h5>Material Ui</h5>
          </div>

          <div>
            <SiChakraui />
            <h5>Chakra Ui</h5>
          </div>
        </div>
      </div>
    </>
  );
};
